jQuery(function($) {

	var _ = {};

	var $win = $(window);
	var $doc = $(document);
	var $body = $('body');
	var $header = $('header');
	var $menu = $header.find('>.wrapper>.menu');
	var $parallax = $('.parallax');
	var $innerPageContent = $('#inner-page > .content');
	var $pageInfo = $('#page-info');

	autosize($('textarea'));

	init_sticky_header();
	// init_parallax();

	init_enroll_course();

	init_links();
	init_blocks();
	init_iframes();

	init_comments();

	init_a();
	init_profile();

	init_quick_pay();

	init_gotoup();
	init_gotoback();
	init_consult_form();


	var __consultForm = $('#consult-form');

	function init_profile() {
		var $file = $('#avatar-upload-file');
		if( !$file.length )
			return;

		var $userInfo = $('.user-info');
		var $editForm = $('.edit-form');

		$('.user-info .edit').on('click', function() {
			$editForm.find('.error').hide();
			$userInfo.hide();
			$editForm.show();
		});
		$('#submit-edit-form').on('click', function(e) {
			e.preventDefault();

			var $userName = $('#user-name').on('keydown', resetError);
			var $userLastName = $('#user-last-name').on('keydown', resetError);
			var $userEmail = $('#user-email').on('keydown', resetError);
			var $userPhone = $('#user-phone').on('keydown', resetError);

			function resetError() {
				$(this).removeClass('error');
			}

			var data = {
				action: 'save_user_info',
				name: $userName.val(),
				lastName: $userLastName.val(),
				email: $userEmail.val(),
				phone: $userPhone.val()
			};

			var error = false;
			if( !data.phone ) {
				$userPhone.addClass('error').focus();
				error = true;
			}
			if( !data.email || !/^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/.test(data.email) ) {
				$userEmail.addClass('error').focus();
				error = true;
			}
			if( !data.lastName ) {
				$userLastName.addClass('error').focus();
				error = true;
			}
			if( !data.name ) {
				$userName.addClass('error').focus();
				error = true;
			}

			if( !error ) {
				var ajax_url = $editForm.attr('action') + '/wp-admin/admin-ajax.php';
				$.post(ajax_url, data, function(result) {
					if( result.success ) {
						$userInfo.find('.name').text(data.name + ' ' + data.lastName);
						$userInfo.find('.email').text(data.email);
						$userInfo.find('.phone').text(data.phone);

						$editForm.hide();
						$userInfo.show();
					} else {
						$editForm.find('.error').fadeIn();
					}
				});
			}

			return false;
		});


		var $avatar = $file.next();
		var $uploader = $avatar.next();

		$uploader.on('click', function() {
			$file.click();
		});
		$file.on('change', function () {
			var data = new FormData();
			$.each(this.files, function(key, value) {
				data.append(key, value);
			});
			data.append('avatar_upload', 1);
			data.append('user', $(this).data('user'));

			$uploader.addClass('show');

			$.ajax({
				url: $(this).data('target'),
				type: 'POST',
				data: data,
				cache: false,
				dataType: 'json',
				processData: false,
				contentType: false,
				success: function(response, status, jqXHR) {
					$uploader.removeClass('show');
					if( typeof response.error === 'undefined' ) {
						var url = $file.data('avatars') + response.file_path + "?x" + new Date().getTime() + '=' + new Date().getTime();
						// console.log(url);
						// $avatar.attr('src', url);

						$avatar.html('<img class="avatar" src="' + url + '"/>');
					} else {
						alert('Ошибка загрузки');
					}
				},
				error: function(jqXHR, status, error) {
					$uploader.removeClass('show');
					console.log(error);
					alert('Ошибка запроса');
				}
			});
		});
	}

	function init_consult_form() {
		$('#open-consult').on('click', function(e) {
			e.preventDefault();
			var $this = $(this);

			var $form = __consultForm;
			var $userName = $form.find('.user-name');
			var $userLastName = $form.find('.user-last-name');
			var $userEmail = $form.find('.user-email');
			var $userPhone = $form.find('.user-phone');

			$modal.show('consult-modal', {
				data: {
					action: 'consult-request'
				},
				afterOpen: function() {
					$userName.focus();
				},
				actions: {
					submit: function(modal, data) {
						data.name = $userName.val();
						data.lastName = $userLastName.val();
						data.email = $userEmail.val();
						data.phone = $userPhone.val();
						var error = false;
						if( !data.phone ) {
							$userPhone.addClass('error').focus();
							error = true;
						}
						if( !data.email ) {
							$userEmail.addClass('error').focus();
							error = true;
						}
						if( !data.lastName ) {
							$userLastName.addClass('error').focus();
							error = true;
						}
						if( !data.name ) {
							$userName.addClass('error').focus();
							error = true;
						}

						if( !error ) {
							var ajax_url = $form.attr('action') + '/wp-admin/admin-ajax.php';
							$.post(ajax_url, data, function(result) {
								$modal.hide();
								var modalId = result.success ? 'consult-success' : 'consult-error';
								$modal.show(modalId, {
									data: data,
									beforeOpen: function(modal, data) {
										modal.find('.name').text(data.name);
									},
									actions: {
										close: function() {
											$modal.hide();
										}
									}
								});
							});
						}
					}
				}
			});
		});
	}

	function init_gotoback() {
		$('#go-to-back').on('click', function() {
			window.history.back();
		});
	}

	function init_gotoup() {
		var $gotoup = $('#go-to-up');
		var WAIT_TIME = 1000; // ms
		var SCROLL_LEN = 400; // px
		var TIMER = 0;
		var SHOW = false;

		$gotoup.on('click', function() {
			// $doc.scrollTop(0);
			$("html,body").animate({scrollTop: 0}, 500);
		});

		$win.on('scroll resize', on_scroll);
		on_scroll();

		function on_scroll() {
			SCROLL_LEN = $win.height() / 2;
			var scrollTop = $doc.scrollTop();
			if( scrollTop < SCROLL_LEN ) {
				if( SHOW ) {
					$gotoup.removeClass('show');
					SHOW = false;
				}
				if( TIMER ) {
					clearTimeout(TIMER);
					TIMER = 0;
				}
			} else {
				if( !SHOW && !TIMER ) {
					TIMER = setTimeout(function() {
						$gotoup.addClass('show');
						SHOW = true;
					}, WAIT_TIME);
				}
			}
		}

	}


	function init_quick_pay() {
		$('.quick-pay').click(function(e) {
			e.preventDefault();
			var $this = $(this);
			var product = $this.data('product');
			var product_id = $this.data('id');

			__email_order(product, product_id);
		});

		function __email_order(product, product_id) {
			$modal.show('email-order-confirmation', {
				actions: {
					accept: function(modal, data) {
						var values = {
							action: 'quick_pay',
							method: 'email_order',
							product: product,
							product_id: product_id
						};

						var ajaxurl = base_url + '/wp-admin/admin-ajax.php';
						$.post(ajaxurl, values, function(result) {
							console.log('Order sent: ' + result.success);
						});
						$modal.hide();
					},
					reject: function(modal, data) {
						$modal.hide();
					}
				}
			});
		}

		function __yandex_money(product, product_id) {
			var values = {
				action: 'quick_pay',
				product: product,
				product_id: product_id
			};

			var ajaxurl = base_url + '/wp-admin/admin-ajax.php';
			$.post(ajaxurl, values, function(result) {
				if( result.success ) {
					submit_quick_pay(result.data);
				} else {
					alert('Ошибка, обратитесь в поддержку!');
				}
			});

			function submit_quick_pay(data) {
				var $form = $('<form class="d-none" method="post" action="https://money.yandex.ru/quickpay/confirm.xml"></form>')
						.append('<input type="hidden" name="receiver" value="' + data['wallet'] + '">')
						.append('<input type="hidden" name="quickpay-form" value="small">')
						.append('<input type="hidden" name="targets" value="' + data['target'] + '">')
						.append('<input type="hidden" name="paymentType" value="' + data['payment_type'] + '">')
						.append('<input type="hidden" name="sum" value="' + data['amount'] + '">')
						// .append('<input type="hidden" name="formcomment" value="' + data['target'] + '-2">')
						// .append('<input type="hidden" name="short-dest" value="' + data['target'] + '-3">')
						.append('<input type="hidden" name="label" value="' + data['label'] + '">')
						.append('<input type="hidden" name="successURL" value="' + data['success-url'] + '">')
						.appendTo($body)
				;
				$form.submit();
			}
		}
	}

	function init_a() {
		if( !$('section.messages').length ) {
			return;
		}

		var $filterCourse = $('#filter-course');
		var $userList = $('.user-list');
		var $userItemTemplate = $('#user-item-template');
		var $userInfo = $('#user-info');
		var $userMessages = $('.user-messages');
		var $userMessageTemplate = $('#user-message-template');
		var $commentList = $userMessages;
		var $replyForm = $('#reply-form');
		var $cancelReply = $('#cancel-reply');
		var $sendReply = $('#send-reply');
		var $replyText = $('#reply-text');
		var $form = $('#comment-form');

		load_user_list();

		$filterCourse.on('change', function(e) {
			load_user_list();
		});

		$userList.on('click', '.user', function(e) {
			e.preventDefault();
			var $this = $(this);

			$userList.children().removeClass('active');
			$this.addClass('active');
			load_user_data($this.data('id'));
		});

		function load_user_list() {
			var course_id = $filterCourse.val();

			var values = {
				action: 'load_user_list',
				course_id: course_id
			};

			var ajaxurl = base_url + '/wp-admin/admin-ajax.php';
			$.post(ajaxurl, values, function(result) {
				if( result.success ) {
					update_user_list(result.data);
				} else {
					update_user_list([]);
				}
			});
		}

		function update_user_list(users) {
			$userList.empty();
			$(users).each(function(i, user) {
				var $user = $userItemTemplate.find('.user').clone();
				$user.attr('data-id', user.id);
				$user.find('.user-avatar').attr('src', user.avatar);
				$user.find('.user-name').text(user.name);
				$user.find('.unread').text(user.priv_unread > 0 ? user.priv_unread : '');
				// $user.find('.unread').text(user.unread);
				if( user.status ) {
					$user.addClass('s-' + user.status);
				}
				$userList.append($user);
			});
			$('.loading-data').detach();
			$('.user-content, .add-user-form').fadeOut(function() {
				$('.select-user').fadeIn();
			});
		}


		function load_user_data(user_id) {
			load_user_info(user_id);
			load_user_messages(user_id);
		}

		function load_user_info(user_id) {
			if( $('.select-user').is(':visible') ) {
				$('.select-user').fadeOut(function() {
					$('.loading-user').fadeIn();
				});
			} else if( $('.add-user-form').is(':visible') ) {
				$('.add-user-form').fadeOut(function() {
					$('.loading-user').fadeIn();
				});
			} else {
				$('.user-content').addClass('loading');
			}
			var course_id = $filterCourse.val();
			var values = {
				action: 'load_user_info',
				user_id: user_id,
				course_id: course_id
			};

			var ajaxurl = base_url + '/wp-admin/admin-ajax.php';
			$.post(ajaxurl, values, function(result) {
				if( result.success ) {
					update_user_info(result.data);
					$userInfo.data('actions', {});
				} else {
				}
			});
		}

		function update_user_info(info) {
			$userInfo.find('.user-avatar').attr('src', info['user_avatar']);
			$userInfo.find('.user-name').text(info['user_name']);
			$userInfo.find('.user-email').text(info['user_email'] || '');
			$userInfo.find('.user-phone').text(info['user_phone'] || '');
			$userInfo.find('.course-title').text(info['course_title']);
			var $status = $userInfo.find('.course-status').removeAttr('href');
			$userInfo.attr('class', info['course_status']).data('info', info);
			switch( info['course_status'] ) {
				case 'unpaid':
					$status.text('Не оплачно: ' + info['course_cost'] + ' руб.');
					break;
				case 'payment':
					$status.text('Ожидание платежа: ' + info['course_cost'] + ' руб.');
					break;
				case 'pending':
					$status.text('Ожидание старта: ' + (info['start_time'] ? info['start_time'] : ''));
					break;
				case 'active':
					$status.text(info['lesson_title']).attr('href', info['lesson_url']);
					break;
				case 'support':
					$status.text('Завершен, поддержка до ' + info['start_time']);
					break;
				case 'finished':
					$status.text('Завершен, доступ до ' + info['start_time']);
					break;
				case 'closed':
					$status.text('Завершен, доступ закрыт');
					break;
			}

			if( $('.loading-user').is(':visible') ) {
				$('.loading-user').fadeOut(function() {
					$('.user-content').fadeIn();
				});
			} else {
				$('.user-content').removeClass('loading');
			}
		}

		function load_user_messages(user_id) {
			var type = 'private-chat';
			$('.user-messages').addClass('loading');
			var values = {
				action: 'load_comments',
				type: type,
				user_id: user_id
			};

			var ajaxurl = base_url + '/wp-admin/admin-ajax.php';
			$.post(ajaxurl, values, function(result) {
				if( result.success ) {
					show_messages(result.data.comments, type, result.data.posts);
				} else {
				}
			});
		}

		function show_messages(list, type, posts) {
			$('.user-messages').empty();
			$(list).each(function(i, comment) {
				append_message(comment, type, posts);
			});
			$('.user-messages').removeClass('loading');
		}

		function append_message(comment, type, posts) {
			if( !type ) {
				// type = currentCommentType;
				type = 'private-chat';
			}
			if( !posts ) {
				posts = {};
			}

			var $comment = $('#user-message-template>.comment').clone();
			$comment.attr('data-id', comment.id).attr('data-uid', comment.user_id).hide();
			$comment.find('.user-avatar').attr('src', comment.avatar).attr('alt', comment.author);
			$comment.find('.user-name').text(comment.author);
			$comment.find('.comment-date').text(comment.date);
			$comment.find('.comment-text').html(comment.text.replace(/\n/g, '<br>'));
			var post = posts[comment.post_id];
			if( post ) {
				$comment.find('.page-link > a').attr('href', '/' + post.name).text((post.parent ? post.parent + ' - ' : '') + post.title).parent().show();
			} else {
				$comment.find('.page-link').hide();
			}
			if( comment.unread ) {
				$comment.addClass('unread');
			}
			if( comment.unapproved ) {
				$comment.addClass('unapproved');
			}

			if( comment.files ) {
				var $files = $comment.find('.comment-files');
				console.log(comment.files);
				$.each(comment.files, function(i, file) {
					$files.append('<div class="file"><a href="' + file['path'] + '">' + file['name'] + '</a></div>');
				});
			}

			var $list;
			if( comment.parent_id && comment.parent_id != '0' ) {
				var $parent = $('.comment[data-id="' + comment.parent_id + '"]');

				$list = $parent.next();
				if( !$list.is('.reply-list') ) {
					$list = $('<div class="reply-list"></div>');
					$parent.after($list);
				}

				// $list = $parent.parent();
				// if( !$list.is('.reply-list') ) {
				// 	$list = $parent.next();
				// 	if( !$list.is('.reply-list') ) {
				// 		$list = $('<div class="reply-list"></div>');
				// 		$parent.after($list);
				// 	}
				// }
			} else {
				// $list = $('#' + type);
				$list = $('.user-messages');
			}

			var $comments = $list.children();
			if( $comments.length == 0 ) {
				$list.append($comment);
			} else {
				if( $comments.first().data('id') < comment.id ) {
					$list.prepend($comment);
				} else if( $comments.last().data('id') > comment.id ) {
					$list.append($comment);
				} else {
					$comments.each(function(i, item) {
						var $item = $(item);
						if( $item.data('id') == comment.id ) {
							// $item.replaceWith($comment);
							return false;
						}
						if( $item.data('id') < comment.id ) {
							$item.before($comment);
							return false;
						}
					});
				}
			}
			$comment.fadeIn();
		}

		var $addUserForm = $('.add-user-form');
		$addUserForm.find('.actions .add').on('click', function() {
			var $lastRow = $addUserForm.find('.user-row').last();
			var $newRow = $lastRow.clone();
			$newRow.insertAfter($lastRow);
			clearUserRow($newRow);
		});
		$addUserForm.find('.actions .register').on('click', function() {
			var $this = $(this);
			$this.attr('disabled', '');

			var course_id = $filterCourse.val();
			var user_data = [];
			$addUserForm.find('.user-row').each(function(i, row) {
				var $row = $(row);
				user_data.push($row.find('.user-name').val() + '|||' + $row.find('.user-last-name').val() + '|||' + $row.find('.user-email').val() + '|||' + $row.find('.user-phone').val());
			});

			var values = {
				action: 'register_users_for_course',
				course_id: course_id,
				user_data: user_data,
				email_subject: $addUserForm.find('.email-subject').val(),
				email_message: $addUserForm.find('.email-message').val(),
			};

			var ajaxurl = base_url + '/wp-admin/admin-ajax.php';
			$.post(ajaxurl, values, function(result) {
				if( result.success ) {
					alert("Пользователи зарегистрированы");

					$addUserForm.find('.user-row').each(function(i, row) {
						if( i == 0 ) {
							clearUserRow($(row));
						} else {
							$(row).detach();
						}
					});

					$addUserForm.hide();
					$('.select-user').fadeOut();
					load_user_list();
				} else {
					alert("Ошибка регистрации пользователей");
				}
				$this.removeAttr('disabled');
			});
		});

		function clearUserRow($row) {
			$row.find('.user-name').val('');
			$row.find('.user-last-name').val('');
			$row.find('.user-email').val('');
			$row.find('.user-phone').val('');
		}

		$('.user-filter >.add-user').on('click', function() {
			var course_id = $filterCourse.val();
			var course_name = $filterCourse.find('option:selected').text();
			$addUserForm.find('>.title>.course-name').text(course_name);

			$('.user-content, .select-user').hide();
			$addUserForm.fadeIn();
		});


		$commentList.on('click', '.unread', function() {
			var $this = $(this);

			var values = {
				action: 'comment_mark_read',
				comment_id: $this.data('id')
			};

			var ajaxurl = base_url + '/wp-admin/admin-ajax.php';
			$.post(ajaxurl, values, function(result) {
				if( result.success ) {
					$this.removeClass('unread');
					var $user = $userList.find('>*[data-id="' + $this.data('uid') + '"]');
					var unread = $user.find('.unread').text() - 1;
					$user.find('.unread').text(unread > 0 ? unread : '');
				}
			});
		});


		$commentList.on('click', '.reply-comment', function() {
			var $this = $(this);
			$replyForm.siblings('.comment-control').show();
			$replyForm.find('.error-message').hide();
			$replyForm.data('comment_id', $this.parents('.comment').data('id'));
			$this.parents('.comment-control').after($replyForm).hide();
		});

		$cancelReply.click(function() {
			$replyForm.siblings('.comment-control').show();
			$replyForm.detach();
		});

		$sendReply.click(function() {
			var $errorMessage = $(this).siblings('.error-message');
			$errorMessage.fadeOut();

/*
			var files = [];
			var uploading = false;
			$fileContainer.find('.file').each(function (i, item) {
				var $file = $(item);
				if( $file.hasClass('upload') ) {
					uploading = true;
					return false;
				}
				files.push($file.data('id'));
			});
*/

			var text = $replyText.val().trim();
			if( !text ) {
			// if( !text || uploading ) {
				$errorMessage.fadeIn();
				return;
			}

			var userInfo = $userInfo.data('info');
			var comment_id = $replyForm.data('comment_id');
			var values = {
				action: 'post_reply',
				page_id: 0,
				comment_id: comment_id,
				text: text
			};
			if( !comment_id ) {
				values['type'] = 'private-chat';
				values['user_id'] = userInfo['user_id'];
				values['page_id'] = userInfo['lesson_id'];
			}

			$replyText.attr('disabled', '');
			$sendReply.attr('disabled', '');
			$cancelReply.attr('disabled', '');

			var ajaxurl = base_url + '/wp-admin/admin-ajax.php';
			$.post(ajaxurl, values, function(result) {
				if( result.success ) {
					$replyText.val('');
					autosize.update($replyText);
					append_message(result.data);
					$replyForm.siblings('.comment-control').show();
					$replyForm.detach();
				} else {
					$errorMessage.fadeIn();
				}

				$replyText.removeAttr('disabled');
				$sendReply.removeAttr('disabled');
				$cancelReply.removeAttr('disabled');
			});
		});

		$userInfo.find('.delete-user').on('click', function() {
			if( !confirm('Пользователь будет удален из курса!') ) {
				return;
			}

			var $this = $(this);
			var info = $userInfo.data('info');
			var userId = info['user_id'];
			var values = {
				action: 'delete_user',
				user_id: userId,
				course_id: info['course_id'],
			};

			$this.attr('disabled', '');

			var ajaxurl = base_url + '/wp-admin/admin-ajax.php';
			$.post(ajaxurl, values, function(result) {
				if( result.success ) {
					$userList.find('>a[data-id="' + userId + '"]').fadeOut(function() {
						$(this).detach();
					});
					$('.user-content').fadeOut(function() {
						$('.select-user').fadeIn();
					});
				} else {
					alert("Ошибка при удалении");
				}
				$this.removeAttr('disabled');
			});
		});

		$userInfo.find('.close-access').on('click', function() {
			if( !confirm('Пользователь не сможет просмотривать курс!') ) {
				return;
			}

			var $this = $(this);
			var info = $userInfo.data('info');
			var userId = info['user_id'];
			var values = {
				action: 'close_access',
				user_id: userId,
				course_id: info['course_id'],
			};

			$this.attr('disabled', '');

			var ajaxurl = base_url + '/wp-admin/admin-ajax.php';
			$.post(ajaxurl, values, function(result) {
				if( result.success ) {
					update_user_info(result.data);

				} else {
					alert("Ошибка запроса");
				}
				$this.removeAttr('disabled');
			});
		});

		$userInfo.find('.post-message').on('click', function() {
			var $this = $(this);
			$replyForm.siblings('.comment-control').show();
			$replyForm.find('.error-message').hide();
			$replyForm.data('comment_id', 0);
			$userInfo.after($replyForm);
			// $this.hide();
		});

		$userInfo.find('.accept-lesson').on('click', function() {
			var $this = $(this);
			var actions = $userInfo.data('actions');
			if( actions['.accept-lesson'] ) {
				return;
			} else {
				actions['.accept-lesson'] = true;
				// $userInfo.data('info', info);
			}

			var info = $userInfo.data('info');
			var values = {
				action: 'confirm_lesson',
				course_id: info['course_id'],
				user_id: info['user_id'],
				request: 'user_info'
			};

			var ajaxurl = base_url + '/wp-admin/admin-ajax.php';
			$.post(ajaxurl, values, function(result) {
				if( result.success ) {
					update_user_info(result.data);

				} else {
					$this.removeAttr('disabled');
					actions['.accept-lesson'] = false;
					// $userInfo.data('info', info);
				}
			});
		});

		$userInfo.find('.accept-payment').on('click', function() {
			var $this = $(this);
			var actions = $userInfo.data('actions');
			if( actions['.accept-payment'] ) {
				return;
			} else {
				actions['.accept-payment'] = true;
				// $userInfo.data('info', info);
			}

			var info = $userInfo.data('info');
			var values = {
				action: 'accept_payment',
				course_id: info['course_id'],
				user_id: info['user_id'],
				request: 'user_info'
			};

			var ajaxurl = base_url + '/wp-admin/admin-ajax.php';
			$.post(ajaxurl, values, function(result) {
				if( result.success ) {
					update_user_info(result.data);

				} else {
					$this.removeAttr('disabled');
					actions['.accept-payment'] = false;
					// $userInfo.data('info', info);
				}
			});
		});

		$userInfo.find('.start-course').on('click', function() {
			var $this = $(this);
			var actions = $userInfo.data('actions');
			if( actions['.start-course'] ) {
				return;
			} else {
				actions['.start-course'] = true;
				// $userInfo.data('info', info);
			}

			var info = $userInfo.data('info');
			var values = {
				action: 'start_course',
				course_id: info['course_id'],
				user_id: info['user_id'],
				request: 'user_info'
			};

			var ajaxurl = base_url + '/wp-admin/admin-ajax.php';
			$.post(ajaxurl, values, function(result) {
				if( result.success ) {
					update_user_info(result.data);

				} else {
					$this.removeAttr('disabled');
					actions['.start-course'] = false;
					// $userInfo.data('info', info);
				}
			});
		});

		$commentList.on('click', '.delete-comment', function() {
			var $this = $(this);
			var $errorMessage = $('#error-message');
			$errorMessage.fadeOut();

			if( !confirm('Комментарий будет удален!') ) {
				return;
			}

			var values = {
				action: 'delete_comment',
				comment_id: $this.parents('.comment').data('id')
			};

			$this.attr('disabled', '');

			var ajaxurl = base_url + '/wp-admin/admin-ajax.php';
			$.post(ajaxurl, values, function(result) {
				if( result.success ) {
					$commentList.find('.comment[data-id="' + values.comment_id + '"]').fadeOut(function() {
						$(this).detach();
					});
				} else {
					$errorMessage.fadeIn();
					$this.removeAttr('disabled');
				}
			});
		});

	}


	function init_comments() {
		if( $('section.messages').length ) {
			return;
		}

		var $form = $('#comment-form');
		var $commentTypes = $('#comment-types');
		var $commentText = $('#comment-text');
		var $commentSend = $('#comment-send');
		var $commentList = $('#comment-list');
		var $privateChat = $('#private-chat');
		var $replyForm = $('#reply-form');
		var $cancelReply = $('#cancel-reply');
		var $sendReply = $('#send-reply');
		var $replyText = $('#reply-text');

		var $file = $('#upload-file');
		var $uploadFiles = $('#upload-files');
		var $rUploadFiles = $('#reply-files');
		var $attachFile = $('#attach-file');
		var $rAttachFile = $('#reply-file');

		var currentCommentType;

		$commentTypes.on('click', '>*', function(e) {
			var $this = $(this);
			if( !$this.hasClass('active') ) {
				$commentTypes.children().removeClass('active');
				$this.addClass('active');
				show_comment_list($this.data('type'));
			}
		});


		// show_comment_list('comment-list'); // private-chat
		var $tab = $commentTypes.children().first();
		$tab.addClass('active');
		show_comment_list($tab.data('type'));


		function show_comment_list(type) {
			currentCommentType = type;
			load_comments(currentCommentType);
			$('.comment-list').hide();
			$('#' + type).show();
			$('.user-selector')[type == 'private-chat' ? 'show' : 'hide']();
		}

		function load_comments(type) {
			var values = {
				action: 'load_comments',
				type: type,
				page_id: $form.find('input[name="page-id"]').val()
			};

			var baseUrl = $form.attr('action') + '/';
			var ajaxurl = baseUrl + 'wp-admin/admin-ajax.php';
			$.post(ajaxurl, values, function(result) {
				if( result.success ) {
					show_comments(result.data.comments, type);
				} else {
				}
			});
		}

		var $fileContainer;
		$uploadFiles.on('click', '.ind', function(e) {
			var $file = $(this).parent();
			$file.detach();
		});
		$rUploadFiles.on('click', '.ind', function(e) {
			var $file = $(this).parent();
			$file.detach();
		});
		$attachFile.on('click', function (e) {
			e.preventDefault();
			$fileContainer = $uploadFiles;
			$file.click();
			return false;
		});
		$rAttachFile.on('click', function (e) {
			e.preventDefault();
			$fileContainer = $rUploadFiles;
			$file.click();
			return false;
		});
		$file.on('change', function () {
			var data = new FormData();
			var items = [];
			$.each(this.files, function(i, file) {
				if( file.size > 5000000 ) {
					alert('Файл ' + file.name + ' слишком большой\nМаксимальный размер 5Мб');
					return;
				}

				var $item = $('<div class="file upload"><span class="name">' + file.name + '</span><div class="ind"></div></div>');
				items.push($item);
				$fileContainer.append($item);
				data.append(i, file);
			});
			if( items.length == 0 ) {
				return;
			}

			data.append('comment_file_upload', 1);
			data.append('user', $(this).data('user'));

			$.ajax({
				url: $(this).data('target'),
				type: 'POST',
				data: data,
				cache: false,
				dataType: 'json',
				processData: false,
				contentType: false,
				success: function(response, status, jqXHR) {
					if( typeof response.error === 'undefined' && response.length ) {
						for( var i = 0; i < response.length; i++ ) {
							var id = response[i];
							if( id != -1 ) {
								items[i].data('id', id).removeClass('upload');
							} else {
								items[i].removeClass('upload').addClass('error');
								alert('Файл ' + items[i].find('.name').text() + ' слишком большой');
							}
						}
					} else {
						console.log(response);
						$.each(items, function(i, $item) {
							$item.removeClass('upload').addClass('error');
						});
						alert('Ошибка загрузки');
					}
				},
				error: function(jqXHR, status, error) {
					$.each(items, function(i, $item) {
						$item.removeClass('upload').addClass('error');
					});
					console.log(error);
					alert('Ошибка запроса');
				}
			});
		});

		$commentSend.on('click', function(e) {
			e.preventDefault();
			var $errorMessage = $('#error-message');
			$errorMessage.fadeOut();

			var files = [];
			var uploading = false;
			if( $fileContainer ) {
				$fileContainer.find('.file').each(function (i, item) {
					var $file = $(item);
					if( $file.hasClass('upload') ) {
						uploading = true;
						return false;
					}
					files.push($file.data('id'));
				});
			}

			var text = $commentText.val().trim();
			if( !text || uploading ) {
				$errorMessage.fadeIn();
				return;
			}

			var values = {
				action: 'post_comment',
				type: currentCommentType,
				page_id: $form.find('input[name="page-id"]').val(),
				text: text
			};
			if( files.length )
				values['attach'] = files;

			$commentText.attr('disabled', '');
			$commentSend.attr('disabled', '');

			var baseUrl = $form.attr('action') + '/';
			var ajaxurl = baseUrl + 'wp-admin/admin-ajax.php';
			$.post(ajaxurl, values, function(result) {
				if( result.success ) {
					$commentText.val('');
					if( $fileContainer ) {
						$fileContainer.empty();
					}
					autosize.update($commentText);
					append_comment(result.data);
				} else {
					$errorMessage.fadeIn();
				}

				$commentText.removeAttr('disabled');
				$commentSend.removeAttr('disabled');
			});
		});

		function show_comments(list, type) {
			$(list).each(function(i, comment) {
				append_comment(comment, type);
			});
		}

		function append_comment(comment, type) {
			if( !type )
				type = currentCommentType;

			var $comment = $('#comment-template>.comment').clone();
			$comment.attr('data-id', comment.id).attr('data-uid', comment.user_id).hide();
			$comment.find('.user-avatar').attr('src', comment.avatar).attr('alt', comment.author);
			$comment.find('.user-name').text(comment.author);
			$comment.find('.comment-date').text(comment.date);
			$comment.find('.comment-text').html(comment.text);
			if( comment.unread ) {
				$comment.addClass('unread');
			}
			if( comment.unapproved ) {
				$comment.addClass('unapproved');
			}

			if( comment.files ) {
				var $files = $comment.find('.comment-files');
				console.log(comment.files);
				$.each(comment.files, function(i, file) {
					$files.append('<div class="file"><a href="' + file['path'] + '">' + file['name'] + '</a></div>');
				});
			}

			var $list;
			if( comment.parent_id && comment.parent_id != '0' ) {
				var $parent = $('.comment[data-id="' + comment.parent_id + '"]');

				$list = $parent.next();
				if( !$list.is('.reply-list') ) {
					$list = $('<div class="reply-list"></div>');
					$parent.after($list);
				}

				// $list = $parent.parent();
				// if( !$list.is('.reply-list') ) {
				// 	$list = $parent.next();
				// 	if( !$list.is('.reply-list') ) {
				// 		$list = $('<div class="reply-list"></div>');
				// 		$parent.after($list);
				// 	}
				// }
			} else {
				$list = $('#' + type);
			}

			var $comments = $list.children();
			if( $comments.length == 0 ) {
				$list.append($comment);
			} else {
				if( $comments.first().data('id') < comment.id ) {
					$list.prepend($comment);
				} else if( $comments.last().data('id') > comment.id ) {
					$list.append($comment);
				} else {
					$comments.each(function(i, item) {
						var $item = $(item);
						if( $item.data('id') == comment.id ) {
							// $item.replaceWith($comment);
							return false;
						}
						if( $item.data('id') < comment.id ) {
							$item.before($comment);
							return false;
						}
					});
				}
			}
			$comment.fadeIn();
		}

		$('.comment-list').on('click', '.unread', function() {
			var $this = $(this);

			var values = {
				action: 'comment_mark_read',
				comment_id: $this.data('id')
			};

			var ajaxurl = base_url + '/wp-admin/admin-ajax.php';
			$.post(ajaxurl, values, function(result) {
				if( result.success ) {
					$this.removeClass('unread');
				}
			});
		});


		$('.comment-list').on('click', '.reply-comment', function() {
			$replyForm.siblings('.comment-control').show();
			$replyForm.find('.error-message').hide();
			$(this).parents('.comment-control').after($replyForm).hide();
		});

		$cancelReply.click(function() {
			$replyForm.siblings('.comment-control').show();
			$replyForm.detach();
		});

		$sendReply.click(function() {
			var $errorMessage = $(this).siblings('.error-message');
			$errorMessage.fadeOut();

			var files = [];
			var uploading = false;
			if( $fileContainer ) {
				$fileContainer.find('.file').each(function (i, item) {
					var $file = $(item);
					if( $file.hasClass('upload') ) {
						uploading = true;
						return false;
					}
					files.push($file.data('id'));
				});
			}

			var text = $replyText.val().trim();
			if( !text || uploading ) {
				$errorMessage.fadeIn();
				return;
			}

			var values = {
				action: 'post_reply',
				page_id: $form.find('input[name="page-id"]').val(),
				comment_id: $replyForm.parents('.comment').data('id'),
				text: text
			};
			if( files.length )
				values['attach'] = files;

			$replyText.attr('disabled', '');
			$sendReply.attr('disabled', '');
			$cancelReply.attr('disabled', '');

			var baseUrl = $form.attr('action') + '/';
			var ajaxurl = baseUrl + 'wp-admin/admin-ajax.php';
			$.post(ajaxurl, values, function(result) {
				if( result.success ) {
					$replyText.val('');
					if( $fileContainer ) {
						$fileContainer.empty();
					}
					autosize.update($replyText);
					append_comment(result.data);
					$replyForm.siblings('.comment-control').show();
					$replyForm.detach();
				} else {
					$errorMessage.fadeIn();
				}

				$replyText.removeAttr('disabled');
				$sendReply.removeAttr('disabled');
				$cancelReply.removeAttr('disabled');
			});
		});

		$('.comment-list').on('click', '.confirm-lesson', function() {
			var $this = $(this);

			var $comment = $this.parents('.comment');
			var values = {
				action: 'confirm_lesson',
				course_id: $pageInfo.data('course-id'),
				comment_id: $comment.data('id'),
				user_id: $comment.data('uid')
			};

			var baseUrl = $form.attr('action') + '/';
			var ajaxurl = baseUrl + 'wp-admin/admin-ajax.php';
			$.post(ajaxurl, values, function(result) {
				if( result.success ) {
					$('.comment-list').find('.comment[data-uid="' + values.user_id + '"]').removeClass('unapproved');
				} else {
					$this.removeAttr('disabled');
				}
			});
		});

		$('.comment-list').on('click', '.delete-comment', function() {
			var $this = $(this);
			var $errorMessage = $('#error-message');
			$errorMessage.fadeOut();

			if( !confirm('Комментарий будет удален!') ) {
				return;
			}

			var values = {
				action: 'delete_comment',
				comment_id: $this.parents('.comment').data('id')
			};

			$this.attr('disabled', '');

			var baseUrl = $form.attr('action') + '/';
			var ajaxurl = baseUrl + 'wp-admin/admin-ajax.php';
			$.post(ajaxurl, values, function(result) {
				if( result.success ) {
					$('.comment-list').find('.comment[data-id="' + values.comment_id + '"]').fadeOut(function() {
						$(this).detach();
					});
				} else {
					$errorMessage.fadeIn();
					$this.removeAttr('disabled');
				}
			});
		});

	}

	function init_links() {
		$('.page-content a.popup[href^="' + document.location.origin + '"]').each(function(i, a) {
			$(a).click(function(e) {
				e.preventDefault();
				$innerPageContent.empty();
				$modal.show('inner-page');

				var values = {
					action: 'load_inner_page',
					href: $(this).attr('href')
				};

				// var baseUrl = $form.attr('action') + '/';
				var ajax_url = base_url + '/wp-admin/admin-ajax.php';
				$.post(ajax_url, values, function(result) {
					if( result.success ) {
						$innerPageContent.html('<h2>' + result.data.title + '</h2>' + result.data.content);
					} else {
					}
				});
			});
		});
	}

	function init_blocks() {
		var $mainBlock = $('#main-block');
		$('.page-content .content-block').each(function(i, block) {
			$(block).addClass('page-content').insertBefore($mainBlock);
		})
	}

	function init_iframes() {
		$('.page-content iframe').each(function(i, frame) {
			var $frame = $(frame);
			var $ratio = $('<div class="ratio"><div class="ratio-16x9"></div></div>');
			$frame.replaceWith($ratio);
			$ratio.append($frame).append('<div class="yt-h1"></div><div class="yt-h2"></div>');
		});
	}


	function init_enroll_course() {
		var $form = $('#enroll-form');
		var $userName = $('#user-name');
		var $userLastName = $('#user-last-name');
		var $userEmail = $('#user-email');
		var $userPhone = $('#user-phone');

		$userName.on('keydown', reset_error);
		$userLastName.on('keydown', reset_error);
		$userEmail.on('keydown', reset_error);
		$userPhone.on('keydown', reset_error);

		function reset_error() {
			$(this).removeClass('error');
		}

		$doc.on('click', '.enroll-course', function(e) {
			e.preventDefault();
			var $this = $(this);

			var courseId = $this.data('course');
			if( !courseId )
				return;

			$modal.show('enroll-course', {
				data: {
					action: 'enroll-course',
					course: courseId
				},
				afterOpen: function() {
					$userName.focus();
				},
				actions: {
					submit: function(modal, data) {
						data.name = $userName.val();
						data.lastName = $userLastName.val();
						data.email = $userEmail.val();
						data.phone = $userPhone.val();
						var error = false;
						if( !data.phone ) {
							$userPhone.addClass('error').focus();
							error = true;
						}
						if( !data.email || !/^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/.test(data.email) ) {
							$userEmail.addClass('error').focus();
							error = true;
						}
						if( !data.lastName ) {
							$userLastName.addClass('error').focus();
							error = true;
						}
						if( !data.name ) {
							$userName.addClass('error').focus();
							error = true;
						}

						if( !error ) {
							var ajax_url = $form.attr('action') + '/wp-admin/admin-ajax.php';
							$.post(ajax_url, data, function(result) {
								$modal.hide();
								var modalId = result.success ? 'enroll-success' : 'enroll-error';
								$modal.show(modalId, {
									data: data,
									beforeOpen: function(modal, data) {
										modal.find('.name').text(data.name);
									},
									actions: {
										close: function() {
											$modal.hide();
										}
									}
								});
							});
						}
					}
				}
			});
		});

	}

	function init_parallax() {
		$parallax.each(function(i, el) {
			var $el = $(el);
			if( $el.children().length > 1 ) {
				var viewHeight = $el.outerHeight();
				var viewTop = $el.offset().top;

				var slide = $el.find('>.active');
				if( slide.length == 0 ) {
					slide = $el.find('>*:nth-child(2)');
				}
				var contentHeight = slide.outerHeight();

				$el.data('parallax-vars', {
					viewHeight: viewHeight,
					viewTop: viewTop,
					contentHeight: contentHeight,
					parallaxOn: false,
					slide: slide
				});
			}
		});

		$win.on('scroll resize', on_scroll);
		on_scroll();

		function on_scroll() {
			$parallax.each(function(i, el) {
				var $el = $(el);
				var _ = $el.data('parallax-vars');
				console.log(_);
				var winHeight = $win.height();
				var scrollTop = $doc.scrollTop() + winHeight;
				console.log(scrollTop);
				if( scrollTop < _.viewTop ) {
					if( _.parallaxOn ) {
						_.parallaxOn = false;
					}
				} else {
					if( !_.parallaxOn ) {
						_.parallaxOn = true;
					}
				}
				if( _.parallaxOn ) {
					var scrollHeight = winHeight + _.viewHeight - 90;
					var scrollProgress = (scrollHeight - (scrollTop - _.viewTop)) / scrollHeight;
					console.log('scrollH: ' + scrollHeight);
					console.log('Progress' + scrollProgress);
					console.log('Scroll: ' + (scrollTop - _.viewTop));
					console.log('Top: ' + -_.contentHeight * scrollProgress);
					_.slide.css({'top': -_.contentHeight * scrollProgress});
				}
			});
		}
	}

	function init_sticky_header() {
		_.stickyHeaderOffset = $header.height();
		_.stickyHeaderScrollTop = $header.height() - $menu.height();
		_.stickyHeaderOn = false;

		$win.on('scroll resize', on_scroll);
		on_scroll();

		function on_scroll() {
			var scrollTop = $doc.scrollTop();
			if( scrollTop < _.stickyHeaderScrollTop ) {
				if( _.stickyHeaderOn ) {
					$body.removeClass('sticky-header').css({'padding-top': ''});
					_.stickyHeaderOn = false;
				}
			} else {
				if( !_.stickyHeaderOn ) {
					$body.addClass('sticky-header').css({'padding-top': _.stickyHeaderOffset});
					_.stickyHeaderOn = true;
				}
			}
		}
	}


});